module.exports = __webpack_public_path__ + "static/img/专利1.c0db6b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/image/专利1.jpg
// module id = qesd
// module chunks = 1